export const downloadXMLfile = (
  filename: string,
  data: BlobPart,
  withoutBom = false,
) => {
  const downloadElement = document.createElement('a');
  const blob = withoutBom
    ? new Blob([data], { type: 'text/xml' })
    : new Blob(['\uFEFF', data], { type: 'text/plain' });

  downloadElement.href = window.URL.createObjectURL(blob);
  downloadElement.download = filename;
  downloadElement.dataset.downloadurl = [
    withoutBom ? 'text/xml' : 'text/plain',
    downloadElement.download,
    downloadElement.href,
  ].join(':');

  downloadElement.click();
  window.URL.revokeObjectURL(downloadElement.href);
};
